module.exports = __webpack_public_path__ + "img/fc1b6b8.png";